import { useEffect } from '../../../src/InBuildImports';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties, systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss } from '../../../src/CommonImports';
import 'bootstrap/dist/css/bootstrap.min.css';

function GJobAboutTeam() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
            <section className="section-box mt-10 mt-md-50">
                <div className="container">
                    <h2 className="section-title text-center mb-15 wow animate__ animate__fadeInUp animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>Meet our team</h2>
                    <div className="text-normal text-center color-black-5 box-mw-60 wow animate__ animate__fadeInUp animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                        Find the type of work you need, clearly defined and ready to start. Work begins as soon as you purchase and provide requirements.
                    </div>
                    <div className="row mt-60">
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card-grid-2  wow animate__ animate__fadeIn animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                                <div className="text-center card-grid-2-image">
                                    <a href="#">
                                        <figure><img src={mediaUrl + "marc.png?" + sasToken} alt="jobhub" /></figure>
                                    </a>
                                </div>
                                <div className="card-block-info pt-10 text-center">
                                    <h5 className="font-bold text-lg mb-0">Elon Musk</h5>
                                    <p className="text-small text-muted">Marketing Crew</p>
                                    <div className="card-2-bottom mt-10">
                                        <a href="#" className="icon-socials icon-facebook"></a>
                                        <a href="#" className="icon-socials icon-twitter"></a>
                                        <a href="#" className="icon-socials icon-instagram"></a>
                                        <a href="#" className="icon-socials icon-linkedin"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card-grid-2  wow animate__ animate__fadeIn animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                                <div className="text-center card-grid-2-image">
                                    <a href="#">
                                        <figure><img src={mediaUrl + "marc2.png?" + sasToken} alt="jobhub" /></figure>
                                    </a>
                                </div>
                                <div className="card-block-info pt-10 text-center">
                                    <h5 className="font-bold text-lg mb-0">Bernard Arnault</h5>
                                    <p className="text-small text-muted">Marketing Crew</p>
                                    <div className="card-2-bottom mt-10">
                                        <a href="#" className="icon-socials icon-facebook"></a>
                                        <a href="#" className="icon-socials icon-twitter"></a>
                                        <a href="#" className="icon-socials icon-instagram"></a>
                                        <a href="#" className="icon-socials icon-linkedin"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card-grid-2  wow animate__ animate__fadeIn animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                                <div className="text-center card-grid-2-image">
                                    <a href="#">
                                        <figure><img src={mediaUrl + "marc3.png?" + sasToken} alt="jobhub" /></figure>
                                    </a>
                                </div>
                                <div className="card-block-info pt-10 text-center">
                                    <h5 className="font-bold text-lg mb-0">Jeff Bezos</h5>
                                    <p className="text-small text-muted">Marketing Crew</p>
                                    <div className="card-2-bottom mt-10">
                                        <a href="#" className="icon-socials icon-facebook"></a>
                                        <a href="#" className="icon-socials icon-twitter"></a>
                                        <a href="#" className="icon-socials icon-instagram"></a>
                                        <a href="#" className="icon-socials icon-linkedin"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card-grid-2  wow animate__ animate__fadeIn animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                                <div className="text-center card-grid-2-image">
                                    <a href="#">
                                        <figure><img src={mediaUrl + "marc4.png?" + sasToken} alt="jobhub" /></figure>
                                    </a>
                                </div>
                                <div className="card-block-info pt-10 text-center">
                                    <h5 className="font-bold text-lg mb-0">Bill Gates</h5>
                                    <p className="text-small text-muted">Marketing Crew</p>
                                    <div className="card-2-bottom mt-10">
                                        <a href="#" className="icon-socials icon-facebook"></a>
                                        <a href="#" className="icon-socials icon-twitter"></a>
                                        <a href="#" className="icon-socials icon-instagram"></a>
                                        <a href="#" className="icon-socials icon-linkedin"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card-grid-2  wow animate__ animate__fadeIn animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                                <div className="text-center card-grid-2-image">
                                    <a href="#">
                                        <figure><img src={mediaUrl + "marc5.png?" + sasToken} alt="jobhub" /></figure>
                                    </a>
                                </div>
                                <div className="card-block-info pt-10 text-center">
                                    <h5 className="font-bold text-lg mb-0">Larry Ellison</h5>
                                    <p className="text-small text-muted">Marketing Crew</p>
                                    <div className="card-2-bottom mt-10">
                                        <a href="#" className="icon-socials icon-facebook"></a>
                                        <a href="#" className="icon-socials icon-twitter"></a>
                                        <a href="#" className="icon-socials icon-instagram"></a>
                                        <a href="#" className="icon-socials icon-linkedin"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card-grid-2  wow animate__ animate__fadeIn animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                                <div className="text-center card-grid-2-image">
                                    <a href="#">
                                        <figure><img src={mediaUrl + "marc6.png?" + sasToken} alt="jobhub" /></figure>
                                    </a>
                                </div>
                                <div className="card-block-info pt-10 text-center">
                                    <h5 className="font-bold text-lg mb-0">Sergey Brin</h5>
                                    <p className="text-small text-muted">Marketing Crew</p>
                                    <div className="card-2-bottom mt-10">
                                        <a href="#" className="icon-socials icon-facebook"></a>
                                        <a href="#" className="icon-socials icon-twitter"></a>
                                        <a href="#" className="icon-socials icon-instagram"></a>
                                        <a href="#" className="icon-socials icon-linkedin"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card-grid-2  wow animate__ animate__fadeIn animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                                <div className="text-center card-grid-2-image">
                                    <a href="#">
                                        <figure><img src={mediaUrl + "marc7.png?" + sasToken} alt="jobhub" /></figure>
                                    </a>
                                </div>
                                <div className="card-block-info pt-10 text-center">
                                    <h5 className="font-bold text-lg mb-0">Mark Zucker</h5>
                                    <p className="text-small text-muted">Marketing Crew</p>
                                    <div className="card-2-bottom mt-10">
                                        <a href="#" className="icon-socials icon-facebook"></a>
                                        <a href="#" className="icon-socials icon-twitter"></a>
                                        <a href="#" className="icon-socials icon-instagram"></a>
                                        <a href="#" className="icon-socials icon-linkedin"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-4">
                            <div className="card-grid-2  wow animate__ animate__fadeIn animated" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                                <div className="text-center card-grid-2-image">
                                    <a href="#">
                                        <figure><img src={mediaUrl + "marc8.png?" + sasToken} alt="jobhub" /></figure>
                                    </a>
                                </div>
                                <div className="card-block-info pt-10 text-center">
                                    <h5 className="font-bold text-lg mb-0">Warren Buffett</h5>
                                    <p className="text-small text-muted">Marketing Crew</p>
                                    <div className="card-2-bottom mt-10">
                                        <a href="#" className="icon-socials icon-facebook"></a>
                                        <a href="#" className="icon-socials icon-twitter"></a>
                                        <a href="#" className="icon-socials icon-instagram"></a>
                                        <a href="#" className="icon-socials icon-linkedin"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default GJobAboutTeam;